module.exports = __webpack_public_path__ + "img/error.9d75483d.svg";